import { createSelector } from 'reselect';
import formatPosition from '../../helpers/positionFormatter';
import config from '../../config';
import { marginTrade } from '../../constants/tradingStyleConstants';
import { positionSelector } from './positionSelectors';
var getInstrumentsWithProductFullNamesAndProductSymbols = function getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product) {
  return instrument.instruments.filter(function (instrument) {
    var product1 = product.products.find(function (product) {
      return product.ProductId === instrument.Product1;
    });
    var product2 = product.products.find(function (product) {
      return product.ProductId === instrument.Product2;
    });
    return product1 && product2;
  }).map(function (instrument) {
    var product1 = product.products.find(function (product) {
      return product.ProductId === instrument.Product1;
    });
    var product2 = product.products.find(function (product) {
      return product.ProductId === instrument.Product2;
    });
    var _ref = product1 && product1,
      Product1Symbol = _ref.Product,
      Product1FullName = _ref.ProductFullName;
    var _ref2 = product2 && product2,
      Product2Symbol = _ref2.Product,
      Product2FullName = _ref2.ProductFullName;
    return Object.assign({}, instrument, {
      Product1FullName: Product1FullName,
      Product2FullName: Product2FullName,
      Product1Symbol: Product1Symbol,
      Product2Symbol: Product2Symbol
    });
  });
};
export var standardInstrumentsWithProductFullNamesAndProductSymbols = createSelector(function (state) {
  return state.apexCore.instrument;
}, function (state) {
  return state.apexCore.product;
}, function (instrument, product) {
  return getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product);
});
var marginInstrumentsWithProductFullNamesAndProductSymbols = createSelector(function (state) {
  return state.margin.instrument;
}, function (state) {
  return state.apexCore.product;
}, function (instrument, product) {
  return getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product);
});
export var instrumentsWithProductFullNamesAndProductSymbols = createSelector(function (state) {
  return state.user.userInfo.MarginBorrowerEnabled;
}, function (state) {
  return state.form.tradingStyle;
}, function (state) {
  return state.margin;
}, function (state) {
  return state;
}, function (marginEnabled, formObj, margin, state) {
  var tradingStyle = void 0;
  if (formObj) {
    tradingStyle = formObj.values.tradingStyle;
  }
  if (margin && marginEnabled && !margin.instrument.fetching && tradingStyle === marginTrade) {
    return marginInstrumentsWithProductFullNamesAndProductSymbols(state);
  }
  return standardInstrumentsWithProductFullNamesAndProductSymbols(state);
});
export var instrumentSelectorInstruments = createSelector(instrumentsWithProductFullNamesAndProductSymbols, function () {
  return config;
}, function (instruments, config) {
  if (config.InstrumentSelector.instruments.length === 0) {
    return instruments;
  }
  return instruments.filter(function (instrument) {
    return config.InstrumentSelector.instruments.includes(instrument.Symbol);
  });
});
var selectedStandardInstrumentSelector = createSelector([instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.apexCore.instrument.selectedInstrumentId;
}], function (instruments, selectedInstrumentId) {
  return instruments.find(function (i) {
    return i.InstrumentId === selectedInstrumentId;
  }) || {};
});
var selectedMarginInstrumentSelector = createSelector([instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}], function (instruments, selectedInstrumentId) {
  return instruments.find(function (i) {
    return i.InstrumentId === selectedInstrumentId;
  });
});
export var selectedInstrumentSelector = createSelector([function (state) {
  return state.user.userInfo.MarginBorrowerEnabled;
}, function (state) {
  return state.form.tradingStyle;
}, function (state) {
  return state.margin;
}, function (state) {
  return state;
}], function (marginEnabled, formObj, margin, state) {
  var tradingStyle = void 0;
  if (formObj) {
    tradingStyle = formObj.values.tradingStyle;
  }
  if (margin && marginEnabled && !margin.instrument.fetching && tradingStyle === marginTrade) {
    return selectedMarginInstrumentSelector(state);
  }
  return selectedStandardInstrumentSelector(state);
});
export default createSelector([positionSelector, selectedInstrumentSelector], function (positions, instrument) {
  var defaultPositions = {
    position1: {},
    position2: {}
  };
  if (!instrument || !positions[instrument.Product1] || !positions[instrument.Product2]) {
    return defaultPositions;
  }
  var position1 = formatPosition(positions[instrument.Product1], instrument.Product1Symbol);
  var position2 = formatPosition(positions[instrument.Product2], instrument.Product2Symbol);
  return {
    position1: position1,
    position2: position2
  };
});